import React from 'react';
import RadioSelect from '../../../FormElements/RadioSelect/RadioSelect';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import imgMountSurface from '../../../../img/MountSurface.jpg';
import imgMountSuspendedDirect from '../../../../img/MountSuspendedDirect.jpg';
import imgMountSuspendedDirectIndirect from '../../../../img/MountSuspendedDirectIndirect.jpg';
import imgWallMountDirect from '../../../../img/WallMountDirect.jpg';
import imgWallMountDirectIndirect from '../../../../img/WallMountDirectIndirect.jpg';
import imgMountRecessed from '../../../../img/MountRecessed.jpg';

import RadioGroup from '@material-ui/core/RadioGroup';


function MountingOptions(props) {

  const {configuration,createItem,setNextEnabled} = props;

  function handleChange(event, value) {

    setNextEnabled(true);
    createItem({id:"mountingOptions",value:value});

    //reset
    createItem({id:"length",value:undefined});
    createItem({id:"quantity",value:undefined});
    createItem({id:"uplightOutput",value:undefined});
    createItem({id:"downlightOutput",value:undefined});
    createItem({id:"cct",value:undefined});
    createItem({id:"cri",value:undefined});
    createItem({id:"voltage",value:undefined});
    createItem({id:"controls",value:undefined});
    createItem({id:"suspensionLength",value:undefined});
    createItem({id:"ceilingType",value:undefined});
    createItem({id:"color",value:undefined});
    createItem({id:"additionalOption",value:undefined});
    createItem({id:"configurations",value:undefined});
  }

  function handleImgClick(value){
    handleChange(null,value);
  }

  return (
    <React.Fragment>
    <RadioGroup
        aria-label="Mounting Options"
        name="mountingOptions"
        onChange={handleChange}
        defaultValue={configuration["mountingOptions"] ? configuration["mountingOptions"] : ''}
        >
        <Grid container spacing={3}>
            <Grid item xs={6} sm={4}>
                <RadioSelect value="SF" label="Surface Mount" img={imgMountSurface}/>
            </Grid>
            <Grid item xs={6} sm={4}>
                <RadioSelect value="SD" label="Suspended Direct" img={imgMountSuspendedDirect}/>
            </Grid>
            <Grid item xs={6} sm={4}>
                <RadioSelect value="SI" label="Suspended Direct/Indirect" img={imgMountSuspendedDirectIndirect}/>
            </Grid>
            <Grid item xs={6} sm={4}>
                <RadioSelect value="WD" label="Wall Mount Direct" img={imgWallMountDirect}/>
            </Grid>
            <Grid item xs={6} sm={4}>
                <RadioSelect value="WI" label="Wall Mount Direct/Indirect" img={imgWallMountDirectIndirect}/>
            </Grid>
            <Grid item xs={6} sm={4}>
                <RadioSelect value="RC" label="Recessed" img={imgMountRecessed}/>
            </Grid>
        </Grid>
        <p className="instructions">Note: Changing the Mounting Option will reset all other values for this configuration.</p>
    </RadioGroup>
    </React.Fragment>
  );
}


export default MountingOptions;









